/**
 *  CDB客人资料查询
 */
import { axios } from '@/utils/request'

const subPath = '/cdb/customer/v2'

export default {
  query,
  detail,
  add,
  update,
  'delete': remove,
  addCustomerTourRecord,
  deleteCustomerTourRecord,
  queryTrash,
  recovery,
  mergeJoinToOtherCustomer,
  getPassport,
  saveTravelDocuments,
  getCusRequest,
  saveCusRequest,
  changeApplyCoupon,
  getCusComingTour,
  getCusCouponDataStatistics,
  getCusInternalNote,
  saveCusInternalNote,
  getCusRelationshipList,
  getAirList,
  saveSingleFFP,
  getAirServiceList,
  queryTourRecord,
  addTourRecord,
  mergeCus,
  previewMergeCus
}

// 分页查询
function query (parameter) {
  return axios({
    url: `${subPath}/query`,
    method: 'get',
    params: { ...parameter, 'page.curPage': parameter.curPage, 'page.pageSize': parameter.pageSize }
  })
}

// 详情
function detail (id) {
  return axios({
    url: `${subPath}/${id}`,
    method: 'get'
  })
}

// 添加
function add (parameter) {
  return axios({
    url: `${subPath}`,
    method: 'post',
    data: parameter
  })
}

// 修改
function update (id, parameter) {
  return axios({
    url: `${subPath}/${id}`,
    method: 'put',
    data: parameter
  })
}

// 删除
function remove (parameter) {
  return axios({
    url: `${subPath}`,
    method: 'delete',
    params: parameter
  })
}

//  客人参团记录添加
function addCustomerTourRecord (id, parameter) {
  return axios({
    url: `${subPath}/${id}/addCustomerTourRecord`,
    method: 'put',
    data: parameter
  })
}

//  客人参团记录删除
function deleteCustomerTourRecord (id, parameter) {
  return axios({
    url: `${subPath}/${id}/deleteCustomerTourRecord`,
    method: 'delete',
    params: parameter
  })
}

// 分页查询 回收站
function queryTrash (parameter) {
  return axios({
    url: `${subPath}/trash/query`,
    method: 'get',
    params: { ...parameter, 'page.curPage': parameter.curPage, 'page.pageSize': parameter.pageSize }
  })
}

// 修改
function recovery (id) {
  return axios({
    url: `${subPath}/trash/recovery/${id}`,
    method: 'put'
  })
}

// 将参团记录合并到其他客人资料
function mergeJoinToOtherCustomer (customerId, targetCustomerCode) {
  return axios({
    url: `${subPath}/${customerId}/mergeJoinToOtherCustomer/${targetCustomerCode}`,
    method: 'put'
  })
}
// 获取护照信息
function getPassport (id) {
  return axios({
    url: `${subPath}/${id}/getPassport`,
    method: 'get'
  })
}

function saveTravelDocuments (parameter, customerId) {
  return axios({
    url: `${subPath}/saveTravelDocuments/${customerId}`,
    method: 'post',
    data: parameter
  })
}

function getCusRequest (id) {
  return axios({
    url: `${subPath}/${id}/getCusRequest`,
    method: 'get'
  })
}

function saveCusRequest (parameter) {
  return axios({
    url: `${subPath}/saveCusRequest`,
    method: 'post',
    data: parameter
  })
}

function changeApplyCoupon (parameter) {
  return axios({
    url: `${subPath}/changeApplyCoupon`,
    method: 'post',
    data: parameter
  })
}

function getCusComingTour (id) {
  return axios({
    url: `${subPath}/${id}/getCusComingTour`,
    method: 'get'
  })
}

function getCusCouponDataStatistics (cdbCode) {
  return axios({
    url: `${subPath}/${cdbCode}/getCusCouponDataStatistics`,
    method: 'get'
  })
}

function getCusInternalNote (globalCode) {
  return axios({
    url: `${subPath}/${globalCode}/getCusInternalNote`,
    method: 'get'
  })
}

function saveCusInternalNote (globalCode, parameter) {
  return axios({
    url: `${subPath}/${globalCode}/saveCusInternalNote`,
    method: 'post',
    data: parameter
  })
}

function getCusRelationshipList () {
  return axios({
    url: `${subPath}/getCusRelationshipList`,
    method: 'get'
  })
}

function getAirList () {
  return axios({
    url: `${subPath}/getAirList`,
    method: 'get'
  })
}

function saveSingleFFP (globalCode, parameter) {
  return axios({
    url: `${subPath}/${globalCode}/saveSingleFFP`,
    method: 'post',
    data: parameter
  })
}

function getAirServiceList () {
  return axios({
    url: `${subPath}/getAirServiceList`,
    method: 'get'
  })
}

function queryTourRecord (parameter) {
  return axios({
    url: `${subPath}/queryTourRecord`,
    method: 'get',
    params: { ...parameter, 'page.curPage': parameter.curPage, 'page.pageSize': parameter.pageSize }
  })
}

function addTourRecord (globalCode, bkrId) {
  return axios({
    url: `${subPath}/${globalCode}/addTourRecord/${bkrId}`,
    method: 'get'
  })
}

function mergeCus (customerId, parameter) {
  return axios({
    url: `${subPath}/mergeCus/${customerId}`,
    method: 'post',
    data: parameter
  })
}

function previewMergeCus (customerId, parameter) {
  return axios({
    url: `${subPath}/previewMergeCus/${customerId}`,
    method: 'post',
    data: parameter
  })
}